import logo from './logo.svg';
import './App.css';
import './Treatments/treat.css';
import './css/my.css';
import './pages/page.css'


import React, { useState, useEffect } from "react";

import PopupAd from './Treatments/PopupAd';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './component/Layout';
import Navbar from './component/Navbar';
import About from './component/About';
import Contact from './component/Contact';
import Photoes from './component/Photoes';
import Videos from './component/Videos';
import Mehrotra from './component/Mehrotra';
import Surgery from './pages/Surgery';
import MaxillofacialSurgery from './pages/MaxillofacialSurgery';
import Neurologist from './pages/Neurologist';
import Ent from './pages/Ent';
import Urosurgery from './pages/Urosurgery';
import Cardiology from './pages/Cardiology';
import Treatments from './pages/Treatments';

function App() {

  

  return (
    <div className='main'>
      <Router>
        {/* <Mehrotra /> */}
        <Navbar />

     

        <Routes>
          <Route path="*" element={<Layout />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Photoes" element={<Photoes />} />
          <Route path="/Videos" element={<Videos />} />
          

          <Route path="/Surgery" element={<Surgery />} />
          <Route path="/MaxillofacialSurgery" element={<MaxillofacialSurgery />} />
          <Route path="/Neurologist" element={<Neurologist />} />
          <Route path="/Ent" element={<Ent />} />
          <Route path="/Urosurgery" element={<Urosurgery />} />
          <Route path="/Cardiology" element={<Cardiology />} />
          <Route path="/Treatments" element={<Treatments />} />



        </Routes>
      </Router>
    </div>
  );
}

export default App;
